import ComponentStyles from './Styles';

export const Styles = ComponentStyles;
const { Icon } = Styles;
export default Icon;
